import React from "react";

type AddButtonProps = {
    onClick: () => void;
};

const ConfigureButton: React.FC<AddButtonProps> = ({onClick}) => {
    return (
        <button
            className="flex items-center gap-2 bg-blue-900 text-white px-4 py-2 rounded-lg hover:bg-blue-800 transition"
            onClick={onClick}>
            <svg
                className="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor">
                <path
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.527-.94 3.294.826 2.354 2.354a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.527-.826 3.294-2.354 2.354a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.527.94-3.294-.826-2.354-2.354a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.527.826-3.294 2.354-2.354.996.613 2.296.07 2.573-1.066z"
                />
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    strokeWidth={2}
                />
            </svg>
            <span>Configura</span>
        </button>
    )
}

export default ConfigureButton;